import styled from 'styled-components';

export const directionMap = {
  top: 90,
  right: 180,
  bottom: 270,
  left: 0,
};

export const SvgWrapper = styled.div`
  display: inline-flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  cursor: ${p => p.cursor ?? 'auto'};
`;
